<template>
  <div class="branding-filter" :class="{ header: header }">
    <div class="branding-filter__wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SanitasBrandingWrapper',
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style name="header-hero-handling">
/* Special handling for tablet devices for .header */
.branding-filter.header {
  margin-left: calc(-1 * var(--body-offset-horizontal));
  margin-right: calc(-1 * var(--body-offset-horizontal));

  @media (--md) {
    margin-left: calc(-1 * var(--body-offset-horizontal));
    margin-right: calc(-1 * var(--body-offset-horizontal));
  }

  @media (min-width: 1025px) {
    margin-left: calc(-1 * var(--body-offset-horizontal));
    margin-right: calc(-1 * var(--body-offset-horizontal));
  }
}
</style>
<style lang="postcss">
.branding-filter {
  background-color: var(--c-primary-color-1);
  color: var(--c-primary-neutral-3);
  &__wrapper {
    width: 100%;
    margin: auto;
    max-width: 1000px;
  }
  &__content {
    display: flex;
    max-width: 940px;
    margin: 0;
    padding: 35px 30px;
  }
  &__cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
    min-width: 200px;
    flex-wrap: wrap;
    &.half {
      width: calc(50% - 20px);
    }
    .dotcom-radio-group .text-items .radio:first-child {
      padding-bottom: 3px !important;
    }
  }

  &__input {
    height: 50px !important;
    min-width: 150px;
    width: 100%;
    margin-bottom: 0 !important;
    background-color: var(--c-primary-neutral-3);
    label {
      .label .title {
        top: 18px !important;
        left: 12px;
        color: var(--c-secondary-neutral-2) !important;
      }
      input:not([type='checkbox']) {
        margin-top: 0 !important;
        height: 50px !important;
        &:focus:not([readonly]) {
          & ~ .label .title {
            top: 0 !important;
            left: 0;
          }
        }
      }
      &.touched .label .title {
        top: 0 !important;
      }
    }
    .select_label__title {
      color: var(--c-secondary-neutral-2) !important;
    }
  }
  .removeMargin {
    margin-bottom: 0 !important;
  }
}
@media (max-width: 768px) {
  .branding-filter {
    &__content {
      display: block;
      padding: 25px;
    }
    &__cell {
      padding: 0 0 25px 0;
      min-width: auto;
      &.half {
        width: 100%;
      }
      .dotcom-radio-group .text-items .radio:first-child {
        padding-bottom: 0 !important;
      }
    }
  }
}
</style>
